// `src/i18n/zh.js`
import news1img1 from '../pages/News/img/news1/img1.jpeg';
import news1img2 from '../pages/News/img/news1/img2.jpeg';
import news1img3 from '../pages/News/img/news1/img3.jpeg';
import news1img4 from '../pages/News/img/news1/img4.jpeg';

// 第二篇文章圖片
import glassSystem from '../pages/News/img/news2/img1.jpeg';
import glassBoothMap from '../pages/News/img/news2/img2.jpeg';
import glassHallMap from '../pages/News/img/news2/img3.jpeg';
import glassQr from '../pages/News/img/news1/img4.jpeg';

// 第三篇文章圖片
import batterySummitImg1 from '../pages/News/img/news3/img1.jpeg';
import batterySummitImg2 from '../pages/News/img/news3/img2.jpeg';
import batterySummitImg3 from '../pages/News/img/news3/img3.jpeg';

// 第四篇文章圖片
import batteryPreviewImg from '../pages/News/img/news4/img1.jpg';

// 第五篇文章圖片
import aquatechImg1 from '../pages/News/img/news5/img1.png';
import aquatechImg2 from '../pages/News/img/news5/img2.jpeg';

// 第六篇文章圖片
import aquatechPreviewImg1 from '../pages/News/img/news6/img1.png';

// 第七篇文章圖片
import apfeImg1 from '../pages/News/img/news7/img1.jpeg';

// 第八篇文章圖片
import apfePreviewImg1 from '../pages/News/img/news8/img1.png';

// 第九篇文章圖片
import chinaplasImg1 from '../pages/News/img/news9/img1.jpeg';
import chinaplasImg2 from '../pages/News/img/news9/img2.jpeg';
import chinaplasImg3 from '../pages/News/img/news9/img3.jpeg';


const zh = {
  nav: {
    home: '首頁',
    products: '產品',
    solutions: '解決方案',
    about: '公司介紹',
    news: '最新消息',
    contact: '聯絡我們'
  },
  home: {
    banner_title: '歡迎來到微視覺科技',
    banner_subtitle: '專注於智慧檢測與自動化解決方案'
  },
  megaMenu: {
    products: {
      category1: { title: '表面檢測系統' },
      category2: { title: '工業相機' },
      category3: { title: '光源' },
      category4: { title: '軟體' },
      category5: { title: '標籤機' }
    }
  },
  banner: {
    // camera: {
    //   title: '以影像科技\n達成最高效能',
    //   subtitle: '',
    //   description: 'IMAGING SOLUTIONS FOR PEAK PERFORMANCE',
    //   buttonText: '表面檢測系統'
    // },
    sensor: {
      title: '以影像科技\n達成最高效能',
      subtitle: '',
      description: 'IMAGING SOLUTIONS FOR PEAK PERFORMANCE',
      buttonText: '工業相機'
    },
    lighting: {
      title: '精準照明技術\n提升缺陷可見度',
      subtitle: '',
      description: 'PRECISION LIGHTING TECHNOLOGIES TO ENHANCE DEFECT VISIBILITY',
      buttonText: '光源'
    },
    software: {
      title: 'AI智能分類軟體\n高效能影相先驅',
      subtitle: '',
      description: 'AI-POWERED CLASSIFICATION SOFTWARE FOR HIGH-PERFORMANCE IMAGING',
      buttonText: '軟體'
    },
    automation: {
      title: '用於缺陷追溯\n的高速線上標記',
      subtitle: '',
      description: 'High-Speed Inline Marking For Defect Traceability',
      buttonText: '標籤機'
    },
    inspection: {
      title: '以影像科技\n達成最高效能',
      subtitle: '',
      description: 'COMPREHENSIVE INSPECTION SYSTEMS FOR QUALITY ASSURANCE',
      buttonText: '標籤機'
    },
    learnMore: '了解更多'
  },
  solutions: {
    sectionTitle: '產業解決方案',
    film: { title: '塑膠薄膜', description: '提供高精度檢測方案' },
    battery: { title: '鋰電池', description: '提升電池生產良率' },
    pcb: { title: '電子材料', description: '確保電路板品質' },
    nonwoven: { title: '不織布', description: '精準識別材料缺陷' },
    metal: { title: '金屬箔', description: '表面瑕疵無所遁形' },
    paper: { title: '紙', description: '保障紙品印刷質量' },
    solar: { title: '太陽能', description: '優化太陽能板性能' },
    general: { title: '玻璃', description: '提升玻璃製造品質' }
  },
  heroSection: {
    title: '精準辨識每一處瑕疵\n確保品質零誤差',
    description: '交給微覺視,為您的產業打造\n最適合的表面檢測系統',
    button: '索取報價'
  },
  about: {
    title: 'ABOUT',
    wintrissTitle: '提供業界最先進、最穩定的檢測與自動化解決方案',
    paragraph1: '微覺視深耕檢測設備領域超過 25 年，累積完整的光學設計、演算法開發與產線整合經驗。我們以此基礎打造全新世代的表面檢測系統，採用高速全彩工業掃描相機與改良演算法，協助客戶精準掌握材料表面品質。\n\n同時，我們亦自主開發在線 X 光測厚設備，可即時量測材料厚度與基重，提升製程穩定度。針對高階材料的潔淨需求，我們也在 2025 年推出在線超音波集塵系統，提供 99.5% 以上的清潔率，有效降低因雜質產生的製程不良率。',
    paragraph2: '',
    learnMore: '了解更多'
  },
  footer: {
    address: '台北市北投區承德路七段401巷1009號',
    phone: '886-2-2892-8000',
    copyright: '保留所有權利',
    products: {
      title: '產品',
      surfaceInspectionSystem: '表面檢測系統',
      industrialCamera: '工業相機',
      lighting: '光源',
      software: '軟體',
      labeler: '標籤機'
    },
    solutions: {
      title: '解決方案',
      film: '塑膠薄膜',
      battery: '鋰電池',
      pcb: '電子材料',
      nonwoven: '不織布',
      metal: '金屬箔',
      paper: '紙',
      solar: '太陽能',
      glass: '玻璃'
    },
    company: {
      title: '公司',
      about: '關於',
      contact: '聯絡'
    }
  },
  aboutUs: {
    hero: {
      title: '關於微覺視',
      subtitle: '打造工業視覺檢測的領導品牌'
    },
    intro: {
      title: '公司歷史沿革',
      description: '微覺視深耕檢測設備領域超過 25 年，累積完整的光學設計、演算法開發與產線整合經驗。我們以此基礎打造全新世代的表面檢測系統，採用高速全彩工業掃描相機與改良演算法，協助客戶精準掌握材料表面品質。\n' +
        '\n' +
        '同時，我們亦自主開發在線 X 光測厚設備，可即時量測材料厚度與基重，提升製程穩定度。針對高階材料的潔淨需求，我們也在 2025 年推出在線超音波集塵系統，提供 99.5% 以上的清潔率，有效降低因雜質產生的製程不良率。\n' +
        '\n' +
        '此外，微覺視所代理的美國 PROTHERM 紅外線加熱板以高效率電力加熱方式，提供快速、均勻、節能的烘烤加熱能力，適用於各式材料處理流程。\n' +
        '\n'
    },
    vision: {
      title: '我們的願景',
      content: '成為全球工業視覺檢測領域的領導品牌,持續創新技術,提升產品品質。'
    },
    mission: {
      title: '我們的使命',
      content: '透過精準的檢測技術,協助客戶提升生產效率,降低成本,確保零缺陷品質。'
    },
    values: {
      title: '核心價值',
      innovation: { title: '創新', description: '持續研發先進技術' },
      quality: { title: '品質', description: '追求卓越品質標準' },
      service: { title: '服務', description: '提供優質客戶服務' }
    }
  },
  news: {
    title: '最新消息',
    subtitle: '掌握展會與技術最新動態',
    readMore: '閱讀更多',
    back: '返回列表',
    list: {
      cidpex2018: {
        id: 'cidpex-2018',
        title: '展會預告：Wintriss Engineering 誠邀您出席第25屆生活用紙國際科技展覽及會議',
        date: '2018-04-18 ~ 2018-04-20',
        summary: 'Wintriss Engineering 將亮相 CIDPEX 2018，邀請您蒞臨展位 Hall7 7S37。',
        sections: [
          {
            type: 'text',
            content: '全球領先的表面缺陷檢測方案供應商－美國微覺視 (Wintriss Engineering)，將亮相 2018 年 4 月 18-20 日舉辦的第25屆生活用紙國際科技展覽及會議 (CIDPEX 2018)。我們誠摯邀請您蒞臨展臺 (Hall7 7S37)，現場與檢測專家交流。'
          },
          {
            type: 'text',
            content: '我們誠摯的邀請您蒞臨微覺視 (Wintriss Engineering) 展臺(Hall7 7S37)，現場與我們的檢測專家進行交流，了解更多關於自動化表面缺陷檢測在生活用紙領域的頂尖技術。'
          },
          { type: 'image', src: news1img1, alt: 'Wintriss Engineering 紙病檢測系統' },
          {
            type: 'text',
            title: '可檢測缺陷類型',
            content: '孔洞、斑點、黑點、蚊蟲、雜質、塵埃、劃傷、皺紋、破邊、高對比度條痕、膠粘物等雜質'
          },
          { type: 'image', src: news1img2, alt: '7號館展位圖' },
          { type: 'image', src: news1img3, alt: '場館分布圖' },
          {
            type: 'text',
            title: 'Wintriss Engineering 展位信息',
            content: '南京國際博覽中心｜7號展館 7S37｜4月18-20日'
          },
          {
            type: 'text',
            title: '關於我們',
            content: '美國微覺視 (Wintriss Engineering) 檢測技術公司成立於1989年，總部位於美國加州的聖地亞哥市。公司長期致力於智能相機的研發和應用，主打產品是線型掃描智能相機的表面缺陷檢測系統，現已成為表面品質檢測領域的領跑者。公司擁有專利的相機技術、光源技術以及核心軟件系統，技術實力雄厚。Wintriss Engineering 亞洲在臺灣，上海，蘇州，日本，韓國，馬來西亞，印度等地的辦公室，共同致力於為亞洲所有用戶提供最優質、最快捷的服務。'
          },
          {
            type: 'text',
            title: '聯繫方式',
            content: 'Sales Department｜電話：86-21-61283990 / 61918662｜傳真：86-21-61918683｜郵箱：sales@iwscan.com'
          },
          {
            type: 'text',
            title: '關註我們',
            content: '歡迎持續關註以獲得最新技術與展會資訊。'
          },
          { type: 'image', src: news1img4, alt: '關注我們Qrcode' },
        ]
      },
      chinaglass2018: {
        id: 'chinaglass-2018',
        title: '展會預告：Wintriss Engineering 誠邀您出席第29屆中國國際玻璃展 Chinaglass',
        date: '2018-04-19 ~ 2018-04-22',
        summary: '歡迎蒞臨上海新國際博覽中心 E2館 E2-141，現場交流玻璃缺陷檢測技術。',
        sections: [
          { type: 'text', content: '美國微覺視 (Wintriss Engineering)，全球領先的表面缺陷檢測方案供應商，誠邀您參加於2018年4月19-22日舉辦的第29屆中國國際玻璃工業技術展覽會 Chinaglass，現場與我們的檢測專家交流深入了解玻璃領域自動化表面缺陷檢測技術。' },
          { type: 'text', title: '技術優勢', content: '多項圖像處理與光學成像專利，使 WebRanger 能檢測各類高難度玻璃表面缺陷，助力品質把控、提升效率、節約成本。' },
          { type: 'image', src: glassSystem, alt: 'Wintriss Engineering 玻璃檢測系統' },
          { type: 'text', title: '理念', content: '全球領先的表面缺陷檢測專家，為您真正做到［零］缺陷。' },
          { type: 'text', title: '全球安裝', content: 'Wintriss Engineering 在北美、亞洲及歐洲已部署數千套系統。' },
          { type: 'text', title: '展位資訊', content: '上海新國際博覽中心｜E2展館 E2-141' },
          { type: 'text', title: '展會時間', content: '4月19-21日 09:00-17:30｜4月22日 09:00-13:00' },
          { type: 'image', src: glassBoothMap, alt: 'E2展館平面圖' },
          { type: 'image', src: glassHallMap, alt: '場館分布圖' },
          { type: 'text', title: '關於我們', content: '美國微覺視 (Wintriss Engineering) 檢測技術公司成立於1989年，總部位於美國加州聖地牙哥。專注線型掃描智能相機表面缺陷檢測系統，擁有專利相機、光源與核心軟件技術，亞洲據點覆蓋臺灣、上海、蘇州、日本、韓國、馬來西亞、印度等地。' },
          { type: 'text', title: '聯繫方式', content: 'Sales Department｜電話：86-21-61918662｜傳真：86-21-61918683｜郵箱：sales@iwscan.com' },
          { type: 'image', src: glassQr, alt: '關注我們 QRCode' },
          { type: 'text', title: '發布日期', content: '2018-03-26' }
        ]
      },
      batterySummit2017: {
        id: 'battery-summit-2017',
        title: '祝賀 Wintriss Engineering 2017 全球電池膜材峰會圓滿成功',
        date: '2017-06-15 ~ 2017-06-16',
        summary: 'Wintriss Engineering 參與 2017 電池膜材上海峰會並分享鋁塑膜表面缺陷檢測經驗。',
        sections: [
          {
            type: 'text',
            content: '6月15到16日，由 Unima 新材網、中國塑模網主辦的「2017 電池膜材上海峰會」在上海國展寶龍麗筠酒店舉辦。會議集結美、日、韓、臺及中國大陸電池膜材料行業的領袖、企業代表、專家學者與媒體。'
          },
          {
            type: 'text',
            content: '盛會吸引索尼、賽拉尼斯、滄州明珠、星源材質、明基材料、樂凱膠片、道明光學、天鴻新材、福斯特、康得新、南亞塑膠、愛康科技、臺虹、晶茂科技、海優威、遼源鴻圖等多家上市公司高管出席。'
          },
          {
            type: 'text',
            content: '作為表面缺陷檢測的領導者，Wintriss Engineering 分享多年表面缺陷檢測經驗，特別是在鋁塑膜缺陷識別與提升良率上的解決方案。'
          },
          { type: 'image', src: batterySummitImg1, alt: '塑模網 CEO 蒞臨展位' },
          { type: 'image', src: batterySummitImg2, alt: '圓桌會議' },
          { type: 'image', src: batterySummitImg3, alt: '嘉賓論壇' },
          {
            type: 'text',
            title: '發佈日期',
            content: '2017-06-19'
          }
        ]
      },
      batterySummit2017Preview: {
        id: 'battery-summit-2017-preview',
        title: '展會預告：微覺視誠邀您出席全球電池膜材上海峰會',
        date: '2017-06-15 ~ 2017-06-16',
        summary: '微覺視將出席第二屆全球電池膜材上海峰會，分享表面缺陷檢測方案。',
        sections: [
          {
            type: 'text',
            content: '微覺視 Wintriss Engineering 將於 6 月 15–16 日參加由中國塑膜網攜手 Unima 新材網在上海舉辦的 2017 年第二屆全球電池膜材上海峰會。'
          },
          {
            type: 'text',
            content: '現場提供專業鋁塑膜與電池膜材料表面缺陷檢測解決方案，與數百家業界企業共建健康產業生態。'
          },
          { type: 'image', src: batteryPreviewImg, alt: '展會預告' },
          {
            type: 'text',
            title: '發布日期',
            content: '2017-06-13'
          }
        ]
      },
      aquatech2017: {
        id: 'aquatech-2017',
        title: '祝賀 Wintriss Engineering 2017 AQUATECH 圓滿成功',
        date: '2017-06-07 ~ 2017-06-09',
        summary: '參與上海國際水展 AQUATECH CHINA，分享表面缺陷在線檢測成果與技術。',
        sections: [
          {
            type: 'text',
            content: '全球第一大國際水處理展 AQUATECH CHINA 上海國際水展已於 6 月 7 日至 9 日在國家會展中心（上海虹橋）舉辦。Wintriss Engineering 非常榮幸能夠參與本屆展會，與廣大客戶分享多年於表面缺陷在線檢測領域取得的成果與經驗。'
          },
          {
            type: 'text',
            content: '現場嘉賓更加深入了解我司先進的表面缺陷檢測技術與設備，也加深對企業文化的認識。攜手並進，共創輝煌。'
          },
          { type: 'image', src: aquatechImg1, alt: 'AQUATECH 展會現場' },
          { type: 'image', src: aquatechImg2, alt: 'AQUATECH 展會現場2' },
          {
            type: 'text',
            title: '發布日期',
            content: '2017-06-12'
          }
        ]
      },
      aquatech2017Preview: {
        id: 'aquatech-2017-preview',
        title: '展會預告：Wintriss Engineering 參加 2017 AQUATECH 國際水展',
        date: '2017-06-07 ~ 2017-06-09',
        summary: '蒞臨 8.1H813 展位獲得專業水過濾膜檢測方案。',
        sections: [
          {
            type: 'text',
            content: '全球第一大國際水處理展 AQUATECH CHINA 上海國際水展將於 6 月 7 日至 9 日在國家會展中心（上海虹橋）舉辦。美國微覺視 (Wintriss Engineering) 將參加本屆展會，展位號為 8.1H813。'
          },
          {
            type: 'text',
            content: '歡迎各位蒞臨展位，與表面缺陷檢測領導者面對面交流，獲得專業的水過濾膜線上檢測方案。'
          },
          { type: 'image', src: aquatechPreviewImg1, alt: 'AQUATECH 展會預告' },
          {
            type: 'text',
            title: '發布日期',
            content: '2017-06-05'
          }
        ]
      },
      apfe2017: {
        id: 'apfe-2017',
        title: '祝賀 Wintriss Engineering 2017 APFE 圓滿成功',
        date: '2017-05-24 ~ 2017-05-26',
        summary: '參與第十三屆 APFE 上海國際膠粘帶、保護膜及光學膜與功能薄膜展，分享表面檢測技術成果。',
        sections: [
          {
            type: 'text',
            content: '全球膠帶與薄膜專業展締造者——「APFE」第十三屆上海國際膠粘帶、保護膜及光學膜展覽會 & 第十三屆上海國際功能薄膜展覽會已於 2017 年 5 月 24–26 日在國家會展中心（上海·虹橋）舉辦。'
          },
          {
            type: 'text',
            content: '本次展會中，作為在線檢測行業的領跑者，Wintriss Engineering 取得了傑出成績，讓更多客戶深入了解我司先進的表面檢測技術與設備，並更深刻理解企業文化。'
          },
          { type: 'image', src: apfeImg1, alt: 'APFE 展會現場' },
          { type: 'text', title: '發布日期', content: '2017-06-05' }
        ]
      },
      apfe2017Preview: {
        id: 'apfe-2017-preview',
        title: '展會預告：Wintriss Engineering 參加 2017 APFE',
        date: '2017-05-24 ~ 2017-05-26',
        summary: '歡迎蒞臨 T120 展位，獲取專業膠粘帶與薄膜表面檢測方案。',
        sections: [
          {
            type: 'text',
            content: '全球膠帶與薄膜專業展締造者——「APFE」第十三屆上海國際膠粘帶、保護膜及光學膜展覽會 & 第十三屆上海國際功能薄膜展覽會，將於 2017 年 5 月 24–26 日在國家會展中心（上海·虹橋）舉辦。'
          },
          {
            type: 'text',
            content: '美國微覺視 (Wintriss Engineering) 將參加本屆展會，展位號為 T120，歡迎蒞臨展位，與表面缺陷檢測領導者面對面交流，獲得最專業的方案。'
          },
          { type: 'image', src: apfePreviewImg1, alt: 'APFE 展會預告' },
          { type: 'text', title: '發布日期', content: '2017-05-21' }
        ]
      },
      chinaplas2017: {
        id: 'chinaplas-2017',
        title: '祝賀 Wintriss Engineering 2017 CHINAPLAS 圓滿成功',
        date: '2017-05-16 ~ 2017-05-19',
        summary: '參與 CHINAPLAS 2017，分享表面缺陷在線檢測技術成果與經驗。',
        sections: [
          {
            type: 'text',
            content: '第三十一屆中國國際塑料橡膠工業展覽會（CHINAPLAS 2017 國際橡塑展）已於 2017 年 5 月 16–19 日在廣州琶洲國際會展中心舉行。Wintriss Engineering 非常榮幸參與本屆展會。'
          },
          {
            type: 'text',
            content: '展會期間，我司與眾多客戶分享多年在表面缺陷在線檢測領域取得的成果與心得，讓來賓更深入了解先進的檢測技術與設備並加深對企業文化的認識。攜手並進，共創輝煌。'
          },
          { type: 'image', src: chinaplasImg1, alt: 'CHINAPLAS 展會現場' },
          { type: 'image', src: chinaplasImg2, alt: 'CHINAPLAS 展會現場2' },
          { type: 'image', src: chinaplasImg3, alt: 'CHINAPLAS 展會現場3' },
          { type: 'text', title: '發布日期', content: '2017-05-21' }
        ]
      },
      chinaplas2017Preview: {
        id: 'chinaplas-2017-preview',
        title: '展會預告：Wintriss Engineering 參加 2017 Chinaplas 國際橡塑展',
        date: '2017-05-16 ~ 2017-05-19',
        summary: '歡迎蒞臨 9.2J21 展位，了解橡塑行業表面缺陷檢測方案。',
        sections: [
          {
            type: 'text',
            content: '美國微覺視，全球領先的表面缺陷檢測方案供應商，誠邀您參加於 2017 年 5 月 16–19 日舉辦的 2017 國際橡塑展，展位號 9.2J21。'
          },
          {
            type: 'text',
            title: '官方網站',
            content: '更多信息請登錄 Chinaplas 官方網站：https://www.chinaplasonline.com/'
          },
          {
            type: 'text',
            title: '展會信息',
            content: '第三十一屆國際橡塑展｜日期：2017 年 5 月 16–19 日｜開放時間：上午 9:30 - 下午 5:00'
          },
          {
            type: 'text',
            title: '展館地址',
            content: '中國廣州 琶洲 中國進出口商品交易會展館（廣州市琶洲閱江中路 382 號）'
          },
          {
            type: 'text',
            title: '主辦及協辦單位',
            content: '雅式展覽服務有限公司；北京雅展展覽服務有限公司；中國輕工業聯合會–中國塑料加工工業協會；中國塑料機械工業協會；廣東省塑料工業協會；杜塞爾多夫展覽(中國)有限公司；上海塑料行業協會'
          },
          {
            type: 'text',
            title: '贊助單位',
            content: '歐洲塑料和橡膠工業機械製造商協會'
          },
          {
            type: 'text',
            title: '海外支持單位',
            content: '日本塑料機械協會'
          },
          {
            type: 'text',
            title: '國內支持單位',
            content: '安徽省塑料協會；中國橡膠工業協會；福建省塑料工業協會；江蘇省塑料加工工業協會；江西省塑料工業協會；山東省塑料工業協會；深圳市高分子行業協會；臺州市塑料行業協會；浙江省塑料行業協會'
          },
          { type: 'text', title: '發布日期', content: '2017-05-04' }
        ]
      },
    },
    fallback: {
      title: '資料暫不可用'
    }
  }
};

export default zh;

